/* global process */
const PUBLIC_SITE_URL = (process.env.VUE_APP_LF_PUBLIC_URL || 'https://learningfirst.io').replace(/\/$/, '')

export function getContentId(content) {
  const id = content && content._id
  return (typeof id === 'string' ? id : (id && (id.$oid || id.$id))) ||
    (content && (content.bundle_id || content.collection_id)) || ''
}

export function publicContentUrl(type, content, format) {
  const id = getContentId(content)
  if (!id) return ''

  if (type === 'educator-course') return `${PUBLIC_SITE_URL}/educators/courses/${encodeURIComponent(id)}`

  if (type === 'collection') {
    if (format === 'id') return `${PUBLIC_SITE_URL}/collection/${encodeURIComponent(id)}`
    const slug = content.collection_name_url_identifier && content.collection_name_url_identifier.trim()
    return slug ? `${PUBLIC_SITE_URL}/${encodeURIComponent(slug)}` : ''
  }

  if (type === 'bundle') {
    const slug = content.bundle_name_url_identifier && content.bundle_name_url_identifier.trim()
    const identifier = format === 'id' ? id : slug
    return identifier ? `${PUBLIC_SITE_URL}/bundle/${encodeURIComponent(identifier)}` : ''
  }

  return ''
}

export async function copyPublicContentUrl(url) {
  if (!url) throw new Error('Link is unavailable')
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(url)
      return
    } catch (error) {
      // Older or restricted browsers can still allow the selection fallback.
    }
  }

  const textarea = document.createElement('textarea')
  textarea.value = url
  textarea.style.position = 'fixed'
  textarea.style.opacity = '0'
  document.body.appendChild(textarea)
  try {
    textarea.select()
    if (!document.execCommand('copy')) throw new Error('Copy failed')
  } finally {
    document.body.removeChild(textarea)
  }
}
